import apiClient from "./apiClient";
import { KindergartenHeadItem, UserInfoDTO } from "@/types/user";
import {PageResponse} from "@/types/pageResponse";
import {SearchParam} from "@/types/searchParam";
import {ResetPasswordRequest} from "@/types/auth";
import axios from "axios";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;
const BASE_URL_USER = `${BASE_URL}/api/v1/user`;
const CREATE_USER_URL = `${BASE_URL_USER}/save`;
const UPDATE_USER_URL = `${BASE_URL_USER}/update`;
const RESET_PASSWORD_URL = `${BASE_URL_USER}/reset/password`;
const RESET_TO_DEFAULT_URL = `${BASE_URL_USER}/reset/default`;
const FIND_ALL_KINDERGARTEN_HEAD_URL = `${BASE_URL_USER}/do/head/list`
const GET_KINDERGARTEN_HEAD_URL = `${BASE_URL_USER}/do/head`;

export async function createUser(
  token: string,
  data: UserInfoDTO
) {
  try {
    return await apiClient.post(
        CREATE_USER_URL,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }
    )
  } catch (error) {
    console.error("Error fetching directory list:", error);
    throw error;
  }
}

export async function updateUser(
  token: string,
  data: UserInfoDTO
) {
  try {
    return await apiClient.post(
        UPDATE_USER_URL,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }
    )
  } catch (error) {
    console.error("Error fetching directory list:", error);
    throw error;
  }
}

export async function findAllKindergartenHeads(
  token: string,
  params: SearchParam
): Promise<PageResponse<KindergartenHeadItem>> {
  try {
    const response = await apiClient.post<PageResponse<KindergartenHeadItem>>(
      FIND_ALL_KINDERGARTEN_HEAD_URL, params,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching object list:", error);
    throw error;
  }
}

export async function findById(
  token: string,
  id: string | ""
): Promise<KindergartenHeadItem> {
  try {
    const response = await apiClient.get<KindergartenHeadItem>(
      `${GET_KINDERGARTEN_HEAD_URL}/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching object list:", error);
    throw error;
  }
}

const apiResetClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

export async function reset(request: ResetPasswordRequest) {
  try {
    return await apiResetClient.post(
        RESET_PASSWORD_URL,
        request,
    );
  } catch (error) {
    console.error("Error fetching reset password:", error);
    throw error;
  }
}

export async function resetToDefault(userId: string) {
  try {
    return await apiClient.get(
        `${RESET_TO_DEFAULT_URL}/${userId}`
    )
  } catch (error) {
    console.log(error);
  }
}

export async function resetPasswordECP(username: string, cms: string) {
  try {
    const data: any = {
      cms: cms,
      username: username
    };
    return await apiClient.post<string>(
        `${BASE_URL_USER}/reset/password/ecp`,
        data
    ).then((response) => {
      return response;
    }).catch((error) => {
      return Promise.reject(error);
    });
  } catch (error) {
    console.log("error on resetting password");
    throw error;
  }
}
export async function updateUserPhone(phone: string) {
  try {
    return await apiClient.post<string>(
        `${BASE_URL_USER}/update/phone`,
        phone
    ).then((response) => {
      return response;
    }).catch((error) => {
      return Promise.reject(error);
    });
  } catch (error) {
    console.log("error on updating User Phone");
    throw error;
  }
}
